import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const setCustomerSuppressed = {
  name: "setCustomerSuppressed" as const,
  input: z.object({
    customerId: zExt.objectId(),
    action: createEnum(["suppress", "unsuppress"]),
    channel: createEnum(MarketingChannel),
  }),
  output: z.object({}),
};
